import styles from './SecuredAlert.module.scss';

type Props = {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
};

const SecuredAlert = ({ PageData, Model, LayoutModel }: Props) => {
  return (
    <div
      className={styles.wrapper}
      data-type="Alert"
      data-creative-slot="Portal-Home-Top"
      data-alert-name="Attention"
    >
      <div className={styles.header}>{PageData?.AttentionUrgentText}</div>
      <div className={styles.content}>
        <div className={styles.text}>{PageData?.ForeFeitureOfTermText}</div>
      </div>
    </div>
  );
};

export default SecuredAlert;
